/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Session_RegisterInputs */

const th_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เช็คชื่อ`)
};

const en_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Register`)
};

const ja_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出席`)
};

const zh_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`报名`)
};

const es_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscribir`)
};

const pt_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscrever`)
};

const id_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar`)
};

const fr_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscrire`)
};

const tl_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magrehistro`)
};

const vi_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng ký`)
};

const ko_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`등록`)
};

const de_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden`)
};

const ru_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записаться`)
};

const tr_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaydol`)
};

const it_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iscriviti`)
};

const pl_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapisz się`)
};

const uk_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записатися`)
};

const hi_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पंजीकरण करें`)
};

const ar_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التسجيل`)
};

const ms_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar`)
};

const bn_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিবন্ধন`)
};

const zh_tw2_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`報名`)
};

const zh_hk2_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`報名`)
};

const ur_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رجسٹر کریں`)
};

const fa_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ثبت‌نام`)
};

const sw_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jisajili`)
};

const nl_event_session_register = /** @type {(inputs: Event_Session_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inschrijven`)
};

/**
* | output |
* | --- |
* | "Register" |
*
* @param {Event_Session_RegisterInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_session_register = /** @type {((inputs?: Event_Session_RegisterInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Session_RegisterInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_session_register(inputs)
	if (locale === "ja") return ja_event_session_register(inputs)
	if (locale === "zh") return zh_event_session_register(inputs)
	if (locale === "es") return es_event_session_register(inputs)
	if (locale === "pt") return pt_event_session_register(inputs)
	if (locale === "id") return id_event_session_register(inputs)
	if (locale === "fr") return fr_event_session_register(inputs)
	if (locale === "tl") return tl_event_session_register(inputs)
	if (locale === "vi") return vi_event_session_register(inputs)
	if (locale === "ko") return ko_event_session_register(inputs)
	if (locale === "de") return de_event_session_register(inputs)
	if (locale === "ru") return ru_event_session_register(inputs)
	if (locale === "tr") return tr_event_session_register(inputs)
	if (locale === "it") return it_event_session_register(inputs)
	if (locale === "pl") return pl_event_session_register(inputs)
	if (locale === "uk") return uk_event_session_register(inputs)
	if (locale === "hi") return hi_event_session_register(inputs)
	if (locale === "ar") return ar_event_session_register(inputs)
	if (locale === "ms") return ms_event_session_register(inputs)
	if (locale === "bn") return bn_event_session_register(inputs)
	if (locale === "zh-TW") return zh_tw2_event_session_register(inputs)
	if (locale === "zh-HK") return zh_hk2_event_session_register(inputs)
	if (locale === "ur") return ur_event_session_register(inputs)
	if (locale === "fa") return fa_event_session_register(inputs)
	if (locale === "sw") return sw_event_session_register(inputs)
	if (locale === "nl") return nl_event_session_register(inputs)
	return en_event_session_register(inputs)
});